import { useState } from 'react';

interface FAQItem {
  question: string;
  answer: string;
}

const faqData: FAQItem[] = [
  {
    question: '小草影院提供哪些类型的电影资源？',
    answer: '小草影院提供丰富的电影分类，包括动作片、喜剧电影、爱情片、科幻大片、恐怖片、动画电影、悬疑片、剧情片和纪录片等。我们的片库每日更新，覆盖院线大片和最新上映电影，满足不同观众的观影需求。',
  },
  {
    question: '小草影院的电影画质如何？',
    answer: '小草影院所有影片均提供高清画质在线观看。我们采用先进的视频编码技术，支持多种分辨率选择，确保您在不同网络环境下都能获得流畅清晰的观影体验。院线大片更提供超清画质选项。',
  },
  {
    question: '小草影院的片库多久更新一次？',
    answer: '小草影院的片库实行每日更新机制。我们的内容团队会在第一时间跟进最新上映电影和院线大片，确保您能在小草影院看到最新、最热门的影片。新片上线后会在首页"最新上映"模块中展示。',
  },
  {
    question: '如何在小草影院快速找到想看的电影？',
    answer: '小草影院提供多种方式帮助您快速定位心仪影片：1）使用首页搜索框直接搜索电影名称；2）通过电影分类标签（动作片、喜剧、科幻等）按类型浏览；3）查看首页"精选推荐"发现高分好片；4）浏览"最新上映"模块获取近期上线的新电影。',
  },
  {
    question: '小草影院是否需要注册会员？',
    answer: '小草影院目前对所有用户免费开放，无需注册即可在线观看各类电影。您可以直接浏览我们的电影大全，选择感兴趣的影片开始观看。我们致力于为用户提供便捷的观影体验。',
  },
  {
    question: '小草影院是否支持手机端观看？',
    answer: '是的，小草影院全面支持移动端观看。我们的网站采用响应式设计，可以自适应手机、平板和电脑等不同屏幕尺寸，让您随时随地享受高清在线观影体验。',
  },
];

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section className="py-12 md:py-16 px-4 md:px-6 bg-background-100">
      <div className="max-w-3xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900">
            常见问题
          </h2>
          <p className="text-sm text-foreground-500 mt-2">
            关于小草影院的常见疑问解答
          </p>
        </div>

        <div className="space-y-3">
          {faqData.map((faq, index) => (
            <div
              key={index}
              className="bg-background-50 rounded-xl border border-background-200 overflow-hidden"
            >
              <button
                onClick={() => toggleFAQ(index)}
                className="w-full flex items-center justify-between p-4 md:p-5 text-left cursor-pointer"
              >
                <h4 className="text-sm md:text-base font-medium text-foreground-800 pr-4">
                  {faq.question}
                </h4>
                <div className={`w-6 h-6 flex items-center justify-center flex-shrink-0 transition-transform duration-300 ${
                  openIndex === index ? 'rotate-180' : ''
                }`}>
                  <i className="ri-arrow-down-s-line text-foreground-500"></i>
                </div>
              </button>
              <div
                className={`overflow-hidden transition-all duration-300 ${
                  openIndex === index ? 'max-h-96' : 'max-h-0'
                }`}
              >
                <p className="px-4 md:px-5 pb-4 md:pb-5 text-sm text-foreground-600 leading-relaxed">
                  {faq.answer}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'FAQPage',
            mainEntity: faqData.map((faq) => ({
              '@type': 'Question',
              name: faq.question,
              acceptedAnswer: {
                '@type': 'Answer',
                text: faq.answer,
              },
            })),
          }),
        }}
      />
    </section>
  );
}